import SuggestedCategories from "@/components/SearchResultPage/SuggestedCategories/SuggestedCategories";
import { over } from "lodash";

// locales/en.ts
export default {
	hello: "Hello",
	"hello.world": "Hello world!",
	welcome: "Hi,",
	login_text: "Login",
	text: {
		readMore: "Read More",
		readMoreAbout: "Read more about",
		next: "Next",
		previous: "Previous",
		edit: "Edit",
		delete: "Delete",
		company: "Company",
		showDetails: "Show details",
		details: "Details",
		contact: "Contact",
		save: "Save",
		cancel: "Cancel",
		change: "Change",
		lastUpdated: "Last Updated",
		updated: "Updated",
		selectAll: "Select All",
		download: "Download",
		onlineStore: "Online Store",
		apply: "Apply",
		saveUser: "Save User",
		findOutMore: "Find Out More",
		view: "View",
		globalAccess: "Global Access.",
		localSupport: "Local Support.",
		browseRegionalStore:
			"Browse and shop online using our dedicated regional stores.",
		regionLanguage: "Region and language",
	},
	education: {
		notAvailable: "Not available",
		educationalInstructorModal: "Educational Instructor",
		viewBio: "View Bio",
	},
	page: {
		login: {
			newToUs: "New To Us?",
			createAccount: "Create Account",
		},
	},
	form: {
		login: {
			logIn: "Log In",
			email: "Email Address",
			password: "Password",
			rememberMe: "Remember Me",
			forgotPassword: "Forgot Password?",
			newToUs: "New to us?",
			createAccount: "Create Account",
			loginError: "Incorrect email or password. Please try again.",
			subscribeMessaging:
				"Yes, I would like to receive product updates, sales or promotional offers from Movora the group brands.",
		},
		passwordReset: {
			title: "Reset Password",
			email: "Email Address",
			confirmResetPassword:
				"If the email address {email} is linked to an account in our store, we have sent you a password reset email. Please check your inbox and spam folder if you don't see it.",
		},
		changePassword: {
			title: "Change Password",
			currentPassword: "Current Password",
			newPassword: "New Password",
			confirmPassword: "Confirm Password",
			confirmChangePassword:
				"Your password has been successfully updated. Please log in using your new credentials.",
		},
		dateFormat: "YYYY/MM/DD",
		from: "From",
		to: "To",
		open: "Open",
		save: "Save",
		submit: "Submit",
	},
	menu: {
		account: "Account",
		cart: "Cart",
		back: "Back",
		viewAll: "View All",
		orderOnline: "Order Online",
	},
	product: {
		chooseOptions: "Choose Options",
		updateOptions: "Update Options",
		findingOptions: "Finding Options",
		addSingle: "Add Single",
		addMultiple: "Add Multiple",
		relatedItems: "Related Items",
		delivery: "Delivery",
		documentation: "Documentation",
		additionalInformation: "Additional Information",
		afterSalesSupport: "After Sales Support",
		overview: "Overview",
		specification: {
			specification: "Specification",
			description: "Description",
			detail: "Detail",
			brand: "Brand",
		},
		gallery: {
			doubleClick: "Double click image to show gallery",
		},
		length: "Length",
		pleaseSelect: "Please select",
		backOrder: "Back Order",
		outOfStockPreOrder: "Out of Stock - Available for PreOrder",
		areOnBackOrder: "are on back order and will ship separately.",
		limitedStock: "Limited Stock",
		mixedAvailablity: "Mixed Availability",
		jumpTo: "Jump to",
		overviewAndSpecification: "Overview and Specification",
	},
	search: {
		search: "Search",
		searching: "Searching",
		suggestions: "Suggestions",
		SuggestedCategories: "Suggested Categories",
		close: "Close",
		products: "Products",
		loading: "Loading",
		news: "News",
		filters: "Filters",
		sortAndFilter: "Sort and Filter",
		sortBy: "Sort By",
		selectedFilters: "Selected Filters",
		clearFilters: "Clear Filters",
		update: "Update",
		searchResults: "Search Results",
		productResults: "Product Results",
		results: "results",
		default: "Default",
		reset: "Reset",
		newsResults: "News Results for",
		showResults: "Show Results",
		searchViaSkuOrProd: "Search via SKU or Product Name",
		searchUsers: "Search Users",
		noResults: {
			general: "No results found",
			noSuggestions: "No suggestions found",
			noArticlesFound: "No articles found",
			products: {
				noProductsFound: "No products found",
				didYouMean: "Did you mean",
				heading: "Your search didn’t return any product results",
				searchTips: {
					heading: "Search tips",
					tipOne: "Try searching by product type, sku or brand",
					tipTwo: "Check the spelling of your keyword",
					tipThree: "Broaden your search by using fewer or more general words",
				},
			},
			news: {
				didYouMean: "Did you mean",
				heading: "Your search didn’t return any news results",
				searchTips: {
					heading: "Search tips",
					tipOne: "Check the spelling of your keyword ",
					tipTwo: "Try alternate words or selections",
					tipThree: "Broaden your search by using fewer or more general words",
				},
			},
		},
	},
	cart: {
		cart: "Cart",
		myCart: "My Cart",
		checkout: "Checkout",
		emptyCart: "Add items to your cart and they will appear here.",
		limitedStock: "Limited stock",
		mayAlsoNeed: "You May Also Need…",
		addToCart: "Add to Cart",
		outOfStock: "Out of Stock",
		addAllToCart: "Add All to Cart",
		addSelectedToCart: "Add Selected to Cart",
		addedToCart: "Added to Cart",
		addCode: "Add Code",
		removedFromCart: "Removed from cart",
		summary: "Summary",
		shipping: "Shipping",
		toCheckout: "Proceed to Checkout",
		availableCredit: "Available Credit",
		subtotal: "Subtotal",
		addInfo: "Add Info",
		emptyCartPage: "You don’t have anything in your cart",
		startShopping: "Start Shopping",
		total: "Total",
		delivery: "Delivery",
		quantity: "Quantity",
		deleteItem: "Delete Item",
		orderTotal: "Order Total",
	},
	blog: {
		latestNews: "Latest News",
		latestBlogs: "Latest Blogs",
		tag: "Tag",
		relatedNews: "Related News",
		relatedBlogs: "Related Blogs",
		shareBlog: "Share Blog",
		viewAllArticlesOn: "View all articles on ",
		expandShareOptions: "Expand share options",
	},
	account: {
		accountOverview: "Account Overview",
		accountNumber: "Movora Customer Account Number",
		creditBalance: "Credit Balance",
		loginForPricing: "Log in for pricing",
		address: {
			addresses: "Addresses",
			address: "Address",
			addNewDeliveryAddress: "Add New Delivery Address",
			createNewDeliveryAddress: "Create New Delivery Address",
			delivery: "Delivery",
			billing: "Billing",
			deliveryAddress: "Delivery Address",
			billingAddress: "Billing Address",
			defaultDeliveryAddress: "This is your default delivery address",
			useThisAsyourDefaultAddress: "Use this as your default address",
			defaultBillingAddress: "This is your default billing address",
			firstName: "First Name",
			lastName: "Last Name",
			companyName: "Company Name",
			phoneNumber: "Phone Number",
			addressLine1: "Address Line 1",
			addressLine2: "Address Line 2",
			city: "City",
			county: "County",
			postcode: "Postcode",
			country: "Country",
			enterAddressManually: "Enter Address Manually",
			searchAutoCompletePlaceholder: "Enter street name or ZIP code",
		},
		wishlist: {
			myList: "My List",
			createNewList: "Create New List",
			addToList: "Add to List",
			addedToList: "Added to List",
			addedToListError: "Something went wrong",
			addAllToCart: "Add all to Cart",
			duplicateList: "Duplicate List",
			editName: "Edit Name",
			deleteList: "Delete List",
			noWishlists: "You don't have any wishlists",
			backToAllLists: "Back to all lists",
			listItems: "List Items",
			removeSelectedItems: "Remove Selected Items",
			editList: "Edit List",
			listName: "List Name",
		},
		orderSource: "Order Source",
		showDetails: "Show Details",
		order: {
			orders: "Orders",
			latestOrder: "Latest Order",
			viewOrder: "View Order",
			viewAllMyOrders: "View all my orders",
			backToAllOrders: "Back to all orders",
			backToAllInvoices: "Back to all invoices",
			paymentMethod: "Payment Method",
			orderNumber: "Order Number",
			orderDate: "Order Date",
			customerNumber: "Customer Number",
			shippingDetails: "Shipping Details",
			dateShipped: "Date Shipped",
			shippingMethod: "Shipping Method",
			trackingLink: "Tracking Link",
			orderItems: "Order Items",
			orderSummary: "Order Summary",
			orderComments: "Order Comments",
			searchOrders: "Search Order Number",
			shipped: "Shipped",
			awaitingShipment: "Awaiting Shipment",
		},
		quickOrder: {
			quickOrder: "Quick Order",
			quickAdd: "Quick Add",
			uploadCSVFile: "Upload CSV File",
			itemList: "Item List",
			dragAndDropToUpload:
				"Drag & Drop or Upload a CSV file to begin the import process.",
			downloadCSVTemplate: "Download CSV Template",
			noItemsFoundWithSkusProvided: "Unable to find any matching SKUs",
			tooManyItems:
				"Quick order via CSV is limited to 50 skus. Please contact Sales to place a bulk order",
			parsingError: "An error occured while parsing the file",
		},
		invoice: {
			invoices: "Invoices",
			noInvoicesFound: "No invoices found",
			invoiceNumber: "Invoice Number",
			viewInvoice: "View Invoice",
			searchInvoices: "Search Invoices",
			openBalance: "Open Balance",
			totalOpen: "Total Open",
			totalTax: "Total Tax",
			tax: "Tax",
			paid: "Paid",
			due: "Due",
			open: "Open",
			invoiced: "Invoiced",
			invoiceItems: "Invoice Items",
			orderSource: "Order Source",
			orderSourceManual: "Manual",
			orderSourceOnline: "Online",
			orderSourceOffline: "Offline",
			payInvoice: "Pay Invoice",
			printInvoice: "Print Invoice",
			pdfUnavailable: " PDF Unavailable",
		},
		accountSettings: {
			accountSettings: "Account Settings",
			contactDetails: "Contact Details",
			accountSettingsUpdated: "Your account details have been updated",
			accountSettingsUpdateFailed: "Failed to update your account details",
			customerMovoraNumber: "Movora Customer Account Number",
		},
		recentlyViewed: {
			recentlyViewed: "Recently Viewed",
			noRecentlyViewed: "You have no recently viewed items",
		},
		user: {
			userManagement: "User Management",
			addNewUser: "Add New User",
			noUsersFound: "No Users Found",
			userRole: "User Role",
			editUser: "Edit User",
			addUser: "Add User",
			user: "User",
			searchUsers: "Search Users",
		},
	},
	notification: {
		success: "Success",
		error: "Error",
		userAdded: "User added successfully",
		userUpdated: "User updated successfully",
		userRemoved: "User removed successfully",
		areYouSure: "Are you sure you wish to delete:",
		delete: "Delete?",
		yes: "Yes",
		no: "No",
	},
} as const;
